import styled from "styled-components"

export const Container = styled.div`
background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.6rem;
  font-size: 1.6rem;
  margin: 2rem;
  padding: 2rem;


  svg {
    margin-right: 2rem;
    height: 2rem;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
  }
`


export const RuleContainer = styled.div`
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 0.1rem solid ${(props) => props.theme.colors.borderLight};

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

export const Id = styled.div`
  font-size: 1.4rem;
  color: ${(props) => props.theme.colors.greyDark};

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.greyDark};
  }
`

export const RuleTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Discount = styled.div`
  font-size: 1.4rem;
`

export const OrderLineDiscount = styled.div`
  display: flex;
  justify-content: space-between;
  width: 35rem;
  font-size: 1.4rem;
`

export const OtherDiscount = styled.div`
text-decoration: underline;
  cursor: pointer;
`

export const TotalDiscountContainer = styled.div`
border-top: 0.1rem solid ${(props) => props.theme.colors.borderLight};
  margin-top: 2rem;
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const TotalDiscount = styled(OrderLineDiscount)`
font-weight: 700;
  font-size: 1.6rem;
`
